// Main exports for the core library
export { ChatWidget, type ChatWidgetProps } from './ChatWidget';
export type {
  ChatWidgetConfig,
  Message,
  Model,
  ModelsResponse,
  UploadedFile,
  Command,
} from './types';
export { cn } from './utils';

// The routing seam. Exported because `ChatWidgetConfig.routing` is public API:
// a host that wants shareable URLs has to be able to name the type it
// implements, and to reuse the URL format rather than reinvent it.
export type { ChatRouting, ChatRoute, RoutablePanel } from './routing';
export {
  buildHref,
  parseRoute,
  messageElementId,
  isRoutablePanel,
  ROUTABLE_PANELS,
  CONVERSATION_PREFIX,
  MESSAGE_HASH_PREFIX,
} from './routing';

// Re-export hooks for advanced usage
export * from './hooks';

// Re-export API functions for advanced usage
export * from './api';

// Re-export components for customization
export * from './components';
